import { assertNever } from 'owa-assert';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import {
    BOX,
    DROPBOX,
    FACEBOOK,
    GDRIVE,
    ONE_DRIVE_CONSUMER,
    ONE_DRIVE_PRO,
    MAILBOX,
    MAIL_MESSAGE,
    WOPI_BOX,
    WOPI_DROPBOX,
    WOPI_EGNYTE,
} from 'owa-attachment-constants/lib/fileProviders';

export default function convertAttachmentDataProviderTypeToString(
    providerType: AttachmentDataProviderType | null
): string | null {
    // This is for cases such as createReferenceAttachmentForLocalFile, where the providerType is currently null
    // but will be set later. Using == to cover null or undefined.
    if (providerType == null) {
        return null;
    }

    switch (providerType) {
        case AttachmentDataProviderType.OneDrivePro:
            return ONE_DRIVE_PRO;
        case AttachmentDataProviderType.GDrive:
            return GDRIVE;
        case AttachmentDataProviderType.OneDriveConsumer:
            return ONE_DRIVE_CONSUMER;
        case AttachmentDataProviderType.Dropbox:
            return DROPBOX;
        case AttachmentDataProviderType.Box:
            return BOX;
        case AttachmentDataProviderType.WopiBox:
            return WOPI_BOX;
        case AttachmentDataProviderType.WopiDropbox:
            return WOPI_DROPBOX;
        case AttachmentDataProviderType.WopiEgnyte:
            return WOPI_EGNYTE;
        case AttachmentDataProviderType.Mailbox:
            return MAILBOX;
        case AttachmentDataProviderType.Facebook:
            return FACEBOOK;
        case AttachmentDataProviderType.MailMessage:
            return MAIL_MESSAGE;
        default:
            return assertNever(providerType);
    }
}
